import { configureStore } from "@reduxjs/toolkit";
import { userSlice } from "../userSlice";
import { adminSlice } from "../adminSlice";
import { mentorSlice } from "../mentorSlice";
import { menteeSlice } from "../menteeSlice";

export default configureStore({
    reducer: {
      user:userSlice.reducer,
      admin: adminSlice.reducer,
      mentor: mentorSlice.reducer,
      mentee: menteeSlice.reducer,
    },
  });